'use strict';

function MapPopupDirective () {


  function controller ($scope) {

  }

  function compile () {
    return  {
      pre: function () {},
      post: function () {
      }
    };
  }

  return {
    controllerAs: 'MapPopupContentCtrl',
    controller: ['$scope', controller],
    compile: compile,
    scope: true,
    require: ['mapPopupContent', '^map'],
    template: '<div><div ng-transclude></div></div>',
    transclude: true
  };
}

MapPopupDirective.$inject = [];
module.exports = MapPopupDirective;


// WEBPACK FOOTER //
// ./src/app/manager/processing/map/MapPopupDirective.js